module.exports = __webpack_public_path__ + "product-compound-capsule-main-thumb-02.jpg?0f75d9f8dd6a8078d0d496f1e459b623";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-main-thumb-02.jpg
// module id = 96
// module chunks = 0